import { wujiRequest } from "../core/common/wujiRequest";
import getManagePathPrefix from "../tools/getManagePathPrefix";
import { getAbsoluteUrl } from "../tools/microApp";
/**
 * 前端数据源运行端接口
 */
export class CgiFEPluginRuntimeService {
  getBaseUrl() {
    return getAbsoluteUrl(`${getManagePathPrefix({
      isRuntimeRoute: true
    })}/datasource/cgi_front_end_plugin`);
  }
  async list(projectId) {
    const list = await wujiRequest({
      url: this.getBaseUrl(),
      method: 'get',
      params: {
        projectid: projectId
      }
    });
    return list;
  }
}
const cgiFEPluginRuntimeService = new CgiFEPluginRuntimeService();
export default cgiFEPluginRuntimeService;
//# sourceMappingURL=cgiFEPluginRuntimeService.js.map
